export const HEADER_HEIGHT = 58;
export const COLOR_PRIMARY = "#0154b0";
export const COLOR_BLUE_BASE = "#000f7b";
export const COLOR_BLUE_80 = "rgba(0, 15, 123, .8)";
export const COLOR_BLUE_60 = "rgba(0, 15, 123, .6)";
export const COLOR_BLUE_40 = "rgba(0, 15, 123, .4)";
export const COLOR_BLUE_20 = "rgba(0, 15, 123, .2)";
